import {Text, OrderedList, StyledHtml} from '@postenbring/hedwig-react';

export const HowTo = ({headingSteps, prefaceSteps, steps}) => {
    return (
        <>
                            {headingSteps &&
                                <Text variant="h2" className="hds-mb-24-32">{headingSteps}</Text>
                            }
                            {prefaceSteps &&
                                <Text as="p" variant="h3" className="hds-mb-24-32">{prefaceSteps}</Text>
                            }

                            <OrderedList>
                                {steps.map((step, index) => (

                                    <li key={index}>
                                        <Text as="p" variant="body-title" className="hds-mb-16">{step.title}</Text>
                                        <StyledHtml className="hds-mb-24-32" dangerouslySetInnerHTML={{ __html: step.text }} />
                                    </li>
                                ))}
                            </OrderedList>
                        </>
    )
}